import { render, staticRenderFns } from "./TestingPost.vue?vue&type=template&id=67a5ee2a&scoped=true"
import script from "./TestingPost.vue?vue&type=script&lang=js"
export * from "./TestingPost.vue?vue&type=script&lang=js"
import style0 from "./TestingPost.vue?vue&type=style&index=0&id=67a5ee2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a5ee2a",
  null
  
)

export default component.exports